import { Center, Group, Text, Image } from '@mantine/core';
import cn from 'classnames';
import * as React from 'react';

import { IconBox } from 'components/ui/icons/IconBox';
import { useAppConfig } from 'stores/global/RootStore/context';

import s from './IconWithTitle.module.scss';

type IconWithTitleProps = {
  className?: string;
};

const IconWithTitle: React.FC<IconWithTitleProps> = ({ className }) => {
  const { images } = useAppConfig();

  return (
    <Group className={cn(s['icon-with-title'], className)} gap={8} wrap="nowrap">
      {images.mobileLogoUrl ? (
        <Image className={s['icon-with-title__icon']} width={40} height={40} src={images.mobileLogoUrl} />
      ) : (
        <Center className={s['icon-with-title__icon']}>
          <IconBox size={24} color="white" />
        </Center>
      )}
      <Text className={s['icon-with-title__title']} c="gray" tt="uppercase">
        личный кабинет
        <br />
        брокера
      </Text>
    </Group>
  );
};

export default IconWithTitle;
